import React from "react";
import TableView from "../../tables/TableView";
import AddNewButton from "../../buttons/AddNewButton";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";

const headers = [
    {"label": "Kod_Prace", "caption": "Kód Práce", 'filter': 'string'},
    {"label": "Popis", "caption": "Popis", 'filter': 'string'},
    {"label": "Cena", "caption": "Cena", 'filter': 'number'},
]

function ServiceCaseWorks(props) {
    const baseUrl = '/service_case/service_cases_works'
    const baseUrlFrontend = '/service_case_works/service_case_work'
    const initialFilters = [
        {
            'label': 'Kod_Prace',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Popis',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Cena',
            'lookup': '',
            'value': ''
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Kod_Prace',
        }
    ]
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Kod_Prace': `${baseUrlFrontend}/${entry.id}`
        }))
    }

    return (
        <ListViewCommon baseUrlFrontend={baseUrlFrontend}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Vykonané práce"}
        />
        // <div>
        //     <TableView links={links} headers={headers} data={data} delete_single={delete_single} label="Druhy práce"/>
        //     <AddNewButton link={`${baseUrlFrontend}/new`}/>
        // </div>
    )
}

export default ServiceCaseWorks